export * from './installSelectors';
export const LOAD_CONTENT = 'mp/movers/install/LOAD_CONTENT';
export const SELECT_SIK = 'mp/movers/install/SELECT_SIK';
export const SELECT_PRO = 'mp/movers/install/SELECT_PRO';
export const CONFIRM_INSTALL = 'mp/movers/install/CONFIRM_INSTALL';
export const UPDATE_OPTION = 'mp/movers/install/UPDATE_OPTION';
export const SET_DATA = 'mp/movers/install/SET_DATA';
export const SET_TIMESLOTS = 'mp/movers/install/SET_TIMESLOTS';
export const SHOW_FETCHING_SPINNER = 'mp/movers/install/SHOW_FETCHING_SPINNER';
export const HIDE_FETCHING_SPINNER = 'mp/movers/install/HIDE_FETCHING_SPINNER';
export const DL_PAGE_LOADED = 'mp/movers/install/DL_PAGE_LOADED';

export const SIK_INSTALL_OPTION = 'selfInstallation';
export const PRO_INSTALL_OPTION = 'professionalInstallation';

import {change} from 'redux-form';

const initialState = {
  content: {},
  selectedOption: '',
  timeSlotsFetching: false
};

export const moversInstall = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    case UPDATE_OPTION:
      return {
        ...state,
        selectedOption: action.payload
      };

    case SET_TIMESLOTS:
      return {
        ...state,
        content: {
          ...state.content,
          professionalInstallation: {
            ...state.content.professionalInstallation,
            ...action.payload
          }
        }
      };

    case HIDE_FETCHING_SPINNER:
      return {
        ...state,
        timeSlotsFetching: false
      };

    case SHOW_FETCHING_SPINNER:
      return {
        ...state,
        timeSlotsFetching: true
      };

    default:
      return state;
  }
};

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};

export const setData = data => {
  return {
    type: SET_DATA,
    payload: data
  };
};

export const updateInstallationOption = option => {
  return {
    type: UPDATE_OPTION,
    payload: option
  };
};

export const setTimeslots = timeslots => {
  return {
    type: SET_TIMESLOTS,
    payload: timeslots
  };
};

export const selectSik = () => {
  return {
    type: SELECT_SIK
  };
};

export const selectPro = () => {
  return {
    type: SELECT_PRO
  };
};

export const confirmInstall = () => {
  return {
    type: CONFIRM_INSTALL
  };
};

export const hideFetchingSpinner = () => {
  return {
    type: HIDE_FETCHING_SPINNER
  };
};

export const showFetchingSpinner = () => {
  return {
    type: SHOW_FETCHING_SPINNER
  };
};

/* Likely belongs in helpers */
export const setSelectedTimeSlot = timeSlot => {
  return (change('install', 'selectedTimeSlot', timeSlot));
};

export default moversInstall;


/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/install/install.js
 **/